import React from 'react'

/**
 * Determines the style for a side nav menu item,
 * based on if it is currently active or not
 *
 * Either pass keyToCompare and activeKey or isActive
 * @param {string} keyToCompare - optional
 * @param {string} activeKey - optional
 * @param {boolean} isActive - optional
 *
 * @example
 * // 1. Using keyToCompare and activeKey
 * let activeKey = "home"
 * <Menu.Item
 *  style={getNavMenuStyles("home", activeKey, null)}
 * >
 *  Home
 * </Menu.Item>
 *
 * @example
 * // 2. Using isActive
 * <Menu.Item
 *  style={getNavMenuStyles(null, null, true)}
 * >
 *  Home
 * </Menu.Item>
 */

const defaultStyle = {
  fontSize: '0.9rem',
  borderRadius: 'var(--rounded)',
  margin: '0.25rem 0',
}
export const getNavMenuItemStyles: (
  keyToCompare?: string | null,
  activeKey?: string | null,
  isActive?: boolean | null,
  theme?: 'dark' | 'light'
) => React.CSSProperties = (keyToCompare = '', activeKey = '', isActive = false, theme) => {
  if (
    isActive ||
    (keyToCompare === activeKey &&
      typeof keyToCompare === 'string' &&
      typeof activeKey === 'string')
  ) {
    return {
      ...defaultStyle,
      backgroundColor: theme === 'dark' ? 'var(--secondary-300)' : 'var(--secondary-400)',
      color: 'white',
      border: 'none',
      fontWeight: 500,
    }
  }
  return {
    ...defaultStyle,
    color: theme === 'dark' ? 'var(--secondary-100)' : 'var(--gray-400)',
  }
}
